import { t } from 'i18next';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import VitalsFields from './form/vitals-fields';
import SysExaminationFields from './form/sys-examiation-fields';
import Complaints from './form/complaints';
import TextareaField from './form/textarea-field';
import Diagnosis from './form/diagnosis';
import RxComponent from './form/rx';
import ReferTo from './form/refer-to';
import NextVisit from './form/next-visit';
import TestDeadline from './form/test-deadline';
import TestRequired from './form/test-required';
import Advise from './form/advise';
import DietExercise from './form/dietExercise';
import { visitInitialValues, setVisitInitialValues, visitValidationSchema } from './composables';

const VisitForm = ({ formRef, selectedVisit }) => {
	const [initialValues, setInitialValues] = useState(visitInitialValues);
	useEffect(() => {
		if (selectedVisit) {
			setInitialValues(setVisitInitialValues(selectedVisit));
		}
	}, [selectedVisit]);
	return (
		<Formik
			innerRef={formRef}
			initialValues={initialValues}
			enableReinitialize={true}
			validationSchema={visitValidationSchema}
			id="visit-form"
			autoComplete="off"
		>
			{() => {
				return (
					<Card.Body>
						<VitalsFields />
						<SysExaminationFields />
						<Complaints customTitle={t('VISIT.COMPLAINTS')} />
						<TextareaField label={t('VISIT.HISTORY')} name="history" />
						<Diagnosis customTitle={t('VISIT.DIAGNOSIS_TITLE')} />
						<RxComponent customTitle={t('VISIT.RX')} />
						<Advise />
						<TestRequired />
						<TestDeadline />
						<DietExercise />
						<ReferTo />
						<NextVisit />
					</Card.Body>
				);
			}}
		</Formik>
	);
};

export default VisitForm;
